import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {TOKEN_CREATION_TIME} from '../constants/local-storage-constants';
import {StorageService} from "../services/storage.service";

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  readonly tokenLife: number = 3540; // 59 minutes

  constructor(private authService: AuthService, private storageService: StorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const now = Math.floor(Date.now() / 1000);
    const tokenCreationTime = parseInt(localStorage[TOKEN_CREATION_TIME]);
    if (now - tokenCreationTime > this.tokenLife) {
      this.authService.logout('Session expired, please log in again');
      return EMPTY;
    }
    const token = this.authService.getToken();

    let headers = {};

    // Keyed on the domain rather than the loaded user: the backend requires this header,
    // and requests can go out before the user profile resolves on a fresh page load.
    const domain = this.storageService.getDomain();
    if (req.url.includes('/api/finra') && !req.headers.has('aodocs-domain') && domain) {
      headers['aodocs-domain'] = domain;
    }

    if (!req.headers.has('Authorization')) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    req = req.clone({
      setHeaders: headers
    });

    return next.handle(req);
  }
}
